import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Input, Button } from 'antd';
import Form from '../../components/Form';
import { showNotification, ERROR_TYPE } from '../../components/Notification';
import styles from './index.module.scss';
import { LAYOUT_0_24, VALIDATE_MESSAGES } from '../../constants/form';

import WealthieBreadCrumb from '../../components/BreadCrumb';
import withLoading from '../../helpers/withLoadingHOC';
import {
  confirmPasswordValidator,
  passwordValidator,
} from '../../helpers/validators';
import { Auth } from 'aws-amplify';
import { get } from 'lodash';
import { useHistory } from 'react-router-dom';

function UpdateSuperAdminPW(): React.ReactElement {
  const [form] = Form.useForm();
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const breadcrumbConfig = useMemo(
    () => [
      {
        name: 'Wealthie',
      },
      {
        name: 'Update super admin password',
      },
    ],
    [],
  );

  useEffect(() => {
    // fetch initial data, check admin
    Auth.currentAuthenticatedUser().then(
      ({
        attributes: { email, family_name: lastName, given_name: firstName },
      }) => {
        form.setFieldsValue({
          email,
          firstName,
          lastName,
        });
      },
    );
  }, [form]);
  // ['custom:role']: role,
  const onFinish = useCallback(
    ({ password, oldPassword }) => {
      setLoading(true);
      Auth.currentAuthenticatedUser()
        .then((user) => Auth.changePassword(user, oldPassword, password))
        .then(() => {
          setLoading(false);
          history.push('/user-admin');
          showNotification({
            type: 'success',
            message: 'Updated account successfully!',
          });
        })
        .catch((err) => {
          setLoading(false);
          showNotification({
            type: 'error',
            message: get(
              err,
              'message',
              'Somethings went wrong, please try again',
            ),
          });
        });
    },
    [history],
  );

  const onFinishFailed = useCallback(() => {
    showNotification({
      type: ERROR_TYPE,
      message: 'Please fill in proper form values.',
    });
  }, []);

  return (
    <>
      <WealthieBreadCrumb breadcrumbConfig={breadcrumbConfig} />
      <div data-testid="edit_profile_page" className={styles.wrapper}>
        <div className={styles.create_admin_wrapper}>
          <Form
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            form={form}
            validateMessages={VALIDATE_MESSAGES}
            {...LAYOUT_0_24}
            data-testid="edit_profile_form"
          >
            <Form.Item rules={[{ required: true }]} label="Email" name="email">
              <Input
                disabled
                aria-label="email-input"
                placeholder="Your Email"
              />
            </Form.Item>
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[{ required: true }]}
            >
              <Input
                disabled
                aria-label="fName-input"
                placeholder="Your First Name"
              />
            </Form.Item>
            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[{ required: true }]}
            >
              <Input
                disabled
                aria-label="lName-input"
                placeholder="Your Last Name"
              />
            </Form.Item>
            <Form.Item
              label="Old password"
              name="oldPassword"
              rules={[{ required: true }]}
            >
              <Input
                type="password"
                aria-label="old-password-input"
                placeholder="Your Old Password"
              />
            </Form.Item>

            <Form.Item
              label="Your New Password"
              name="password"
              rules={[{ required: true, validator: passwordValidator }]}
            >
              <Input
                placeholder="Your New Password"
                type="password"
                data-testid="pwd_input"
              />
            </Form.Item>
            <Form.Item
              label="Repeat Password"
              name="repeatPassword"
              dependencies={['password']}
              rules={[
                (form) => ({
                  validator(_, value) {
                    return confirmPasswordValidator(
                      value,
                      form.getFieldValue('password'),
                    );
                  },
                }),
                { required: true },
              ]}
            >
              <Input
                placeholder="Repeat Password"
                type="password"
                data-testid="repeat_pwd_input"
              />
            </Form.Item>

            <Form.Item className={styles.action_section}>
              <Button
                loading={isLoading}
                type="primary"
                htmlType="submit"
                data-testid="save_button"
                className={styles.save_button}
              >
                Save
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
}

export default withLoading(UpdateSuperAdminPW);
